import './CreateFarm.css';

export default function CreateFarm() {
  return (
    <div className="create-farm-page">
      <div className="create-farm-container">
        <h1>Создать ферму</h1>
        <div className="create-farm-content">
          <p>Здесь будет форма создания фермы</p>
        </div>
      </div>
    </div>
  );
}
